// Version : 0.0.1
// Author :
// LastEdit : 
// Last ADD : INITIAL CREATION
// MODIFIED DATE: 

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/******************* FETCH THRIFT REPORT START  ******************************** */
export const fetchThriftReport = (fetchData: any) => {
	const data = {
		GetThriftReportToken: fetchData,
	};
	const url = `${API_URL}getThriftReport`;
	return makeApiCall(url, data);
};
/******************* FETCH THRIFT REPORT END  ******************************** */

